var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-select"},_vm._l((_vm.selectList),function(item,index){return _c('li',{class:_vm.currentType==index?'current':'',on:{"click":function($event){return _vm.chooseNavItem(item,index)}}},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }